// extracted by mini-css-extract-plugin
export default {"root":"homeUser_root__ewWQm","user_root":"homeUser_user_root__WRljP","iconBox":"homeUser_iconBox__YKAZp","name":"homeUser_name__TwiOp"};